/*
 * BIGME Deep Calm PDP
 * Behaviour ported from the design source. Every block is defensive:
 * a section that is not on the page simply does nothing.
 */
(function () {
  'use strict';

  // Each section links this file, so guard against running twice.
  if (window.__bigmePdpLoaded) return;
  window.__bigmePdpLoaded = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  function clamp(v, lo, hi) { return Math.max(lo, Math.min(hi, v)); }

  /* ---------------------------------------------------------
     Lazy video sources
     --------------------------------------------------------- */
  function hydrateVideos(root) {
    (root || document).querySelectorAll('video[data-lazysrc]').forEach(function (v) {
      v.src = v.getAttribute('data-lazysrc');
      v.removeAttribute('data-lazysrc');
    });
  }

  /* ---------------------------------------------------------
     Product gallery
     --------------------------------------------------------- */
  function initGallery(scope) {
    var main = scope.querySelector('.gal-main');
    if (!main) return null;

    var slides = [].slice.call(scope.querySelectorAll('.gal-slide'));
    var thumbs = [].slice.call(scope.querySelectorAll('.gal-thumb'));
    var countEl = scope.querySelector('.gal-count');
    var idx = 0;

    function show(n) {
      if (!slides.length) return;
      idx = (n + slides.length) % slides.length;
      slides.forEach(function (s, i) {
        s.classList.toggle('active', i === idx);
        var v = s.querySelector('video');
        if (v && i !== idx) v.pause();
      });
      thumbs.forEach(function (t, i) {
        t.classList.toggle('active', i === idx);
        t.setAttribute('aria-current', i === idx ? 'true' : 'false');
      });
      if (countEl) countEl.textContent = (idx + 1) + ' / ' + slides.length;
    }

    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () { show(i); });
    });
    var prev = scope.querySelector('.gal-nav.prev');
    var next = scope.querySelector('.gal-nav.next');
    if (prev) prev.addEventListener('click', function () { show(idx - 1); });
    if (next) next.addEventListener('click', function () { show(idx + 1); });

    // Swipe the main stage on touch.
    var sx = 0, sy = 0, tracking = false;
    main.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) return;
      tracking = true;
      sx = e.touches[0].clientX;
      sy = e.touches[0].clientY;
    }, { passive: true });
    main.addEventListener('touchend', function (e) {
      if (!tracking) return;
      tracking = false;
      var t = e.changedTouches[0];
      var dx = t.clientX - sx;
      var dy = t.clientY - sy;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) show(idx + (dx < 0 ? 1 : -1));
    }, { passive: true });

    show(0);

    return { show: show, slides: slides };
  }

  /* ---------------------------------------------------------
     Buy box — tiers, subscription, shipping bar, totals
     --------------------------------------------------------- */
  function initBuyBox(scope) {
    var root = scope.querySelector('[data-buy-box]');
    if (!root) return;

    var form = root.querySelector('#bigme-buy-form');
    var variantInput = root.querySelector('[data-variant-id]');
    var planInput = root.querySelector('[data-selling-plan]');
    // Pack cards: the patch box's .bb-tier, or any card marked data-tier.
    var tiers = [].slice.call(root.querySelectorAll('.bb-tier, [data-tier]'));
    var subLabel = root.querySelector('.bb-sub');
    var subInput = subLabel ? subLabel.querySelector('input[type="checkbox"]') : null;

    // Every price string is rendered by Liquid's own money filter and carried
    // on the tier, so switching packs can never format a price differently
    // from the way the page was served.
    var priceEls = [].slice.call(root.querySelectorAll('[data-sel-price]'));
    var elCompare = root.querySelector('[data-sel-compare]');
    var offEls = [].slice.call(root.querySelectorAll('[data-sel-off]'));
    var elCtaTotal = root.querySelector('[data-cta-total]');
    var elSubPrice = root.querySelector('[data-sub-price]');
    var elSubCompare = root.querySelector('[data-sub-compare]');
    var elSubSave = root.querySelector('[data-sub-save]');
    var shipLine = root.querySelector('[data-ship-line]');
    var shipFill = root.querySelector('.bb-ship-fill');
    var picksLink = root.querySelector('.bb-picks-link');
    var picksWrap = root.querySelector('[data-picks-wrap]');
    var noteWrap = root.querySelector('[data-note-wrap]');
    // Subscription without a selling plan: these ride along on the line item.
    var subProps = [].slice.call(root.querySelectorAll('[data-sub-prop]'));
    var subReturn = root.querySelector('[data-sub-return]');
    var titleSave = root.querySelector('[data-sub-title-save]');
    var titlePlain = root.querySelector('[data-sub-title-plain]');
    var savingClaims = [].slice.call(root.querySelectorAll('[data-sub-saving-claim]'));
    var propWhen = root.getAttribute('data-sub-prop-when') || 'no_plan';
    var atc = root.querySelector('.bb-atc');
    // "Only [stock] left" badges sit in the heading, outside the buy box.
    var stockBadges = [].slice.call(scope.querySelectorAll('[data-stock-badge]'));

    function selectedTier() {
      for (var i = 0; i < tiers.length; i++) {
        var input = tiers[i].querySelector('input');
        if (input && input.checked) return tiers[i];
      }
      return tiers[0] || null;
    }

    function subscriptionOn() {
      return !!(subInput && subInput.checked && !subInput.disabled);
    }

    function render() {
      var tier = selectedTier();
      tiers.forEach(function (t) {
        var input = t.querySelector('input');
        t.classList.toggle('is-sel', !!(input && input.checked));
      });
      if (!tier) return;

      function attr(name) { return tier.getAttribute(name) || ''; }

      var available = attr('data-available') === 'true';
      var planId = attr('data-selling-plan');
      var sub = subscriptionOn();

      var priceF = attr('data-price-f');
      var compareF = attr('data-compare-f');
      var subPriceF = attr('data-sub-price-f');
      var saveF = attr('data-sub-save-f');
      var totalF = sub ? subPriceF : priceF;

      if (variantInput) variantInput.value = attr('data-variant-id');
      if (planInput) planInput.value = sub ? planId : '';

      // A disabled input is not submitted, which is exactly the toggle we want.
      var sendProps = sub && propWhen !== 'never' && (propWhen === 'always' || !planId);
      subProps.forEach(function (el) { el.disabled = !sendProps; });
      // The discount code only matters when no selling plan is doing the work.
      if (subReturn) subReturn.disabled = !(sub && !planId);

      priceEls.forEach(function (el) { el.textContent = priceF; });
      if (elCompare) {
        var wrap = elCompare.closest('.bb-value, [data-compare-wrap]');
        elCompare.textContent = compareF;
        if (wrap) wrap.hidden = !compareF;
      }
      // "17% off" next to an MRP: only while the pack really is discounted.
      offEls.forEach(function (el) {
        var off = attr('data-off-f');
        el.textContent = off;
        el.hidden = !off;
      });
      if (elCtaTotal) elCtaTotal.textContent = available && totalF ? '— ' + totalF : '';
      if (elSubPrice) elSubPrice.textContent = subPriceF;
      if (elSubCompare) elSubCompare.textContent = saveF ? priceF : '';
      if (elSubSave) elSubSave.textContent = saveF;

      // The card only promises a saving when this pack actually gives one.
      var saves = !!saveF;
      if (titleSave) titleSave.hidden = !saves;
      if (titlePlain) titlePlain.hidden = saves;
      savingClaims.forEach(function (el) { el.hidden = !saves; });

      if (subLabel) subLabel.classList.toggle('is-on', sub);
      if (noteWrap) noteWrap.classList.toggle('is-open', sub);
      if (picksWrap) picksWrap.classList.toggle('is-open', !sub && picksWrap.getAttribute('data-open') === 'true');

      // Per-box patch selectors: only the selected tier's rows submit.
      root.querySelectorAll('[data-pick-group]').forEach(function (group) {
        var mine = group.getAttribute('data-pick-group') === attr('data-tier-id');
        group.hidden = !mine;
        group.querySelectorAll('select').forEach(function (sel) { sel.disabled = !mine || sub; });
      });

      if (shipLine) shipLine.textContent = sub ? attr('data-ship-sub') : attr('data-ship-one');
      if (shipFill) {
        var pct = parseInt(sub ? attr('data-ship-sub-pct') : attr('data-ship-one-pct'), 10) || 0;
        shipFill.style.width = clamp(pct, 0, 100) + '%';
        shipFill.classList.toggle('is-full', pct >= 100);
      }

      if (atc) {
        atc.disabled = !available;
        var textEl = atc.querySelector('[data-cta-text]');
        if (textEl) {
          textEl.textContent = available
            ? atc.getAttribute('data-add-label')
            : atc.getAttribute('data-sold-out-label');
        }
      }

      // Stock badges report the pack on screen, and only when it is tracked
      // and at or below the threshold the merchant set.
      if (stockBadges.length) {
        var qty = parseInt(attr('data-stock'), 10) || 0;
        var tracked = attr('data-stock-tracked') === 'true';
        stockBadges.forEach(function (b) {
          var max = parseInt(b.getAttribute('data-stock-max'), 10) || 0;
          b.hidden = !(tracked && qty > 0 && (max <= 0 || qty <= max));
          var count = b.querySelector('[data-stock-count]');
          if (count) count.textContent = qty;
        });
      }

      document.dispatchEvent(new CustomEvent('bigme:total', {
        detail: { total: totalF, label: attr('data-label'), available: available }
      }));
    }

    tiers.forEach(function (t) {
      var input = t.querySelector('input');
      if (input) input.addEventListener('change', render);
    });
    if (subInput) subInput.addEventListener('change', render);
    if (picksLink && picksWrap) {
      picksLink.addEventListener('click', function (e) {
        e.preventDefault();
        var open = picksWrap.getAttribute('data-open') !== 'true';
        picksWrap.setAttribute('data-open', String(open));
        picksLink.textContent = picksLink.getAttribute(open ? 'data-hide' : 'data-show');
        render();
      });
      picksLink.textContent = picksLink.getAttribute(
        picksWrap.getAttribute('data-open') === 'true' ? 'data-hide' : 'data-show'
      );
    }

    render();

    initCartAdd(root, {
      discountCode: function () {
        // Only meaningful while subscribed and with no selling plan doing the work.
        var tier = selectedTier();
        if (!tier || !subscriptionOn()) return '';
        if (tier.getAttribute('data-selling-plan')) return '';
        return root.getAttribute('data-sub-discount') || '';
      },
      discountMessage: function (code) {
        var tpl = root.getAttribute('data-sub-discount-note') || '';
        return tpl.replace('[code]', '<b>' + code + '</b>');
      }
    });
  }

  /* ---------------------------------------------------------
     Add to cart — applies the subscription discount for real,
     then opens the cart drawer showing it.
     --------------------------------------------------------- */
  function initCartAdd(root, opts) {
    var form = root.querySelector('#bigme-buy-form');
    if (!form) return;
    var atc = root.querySelector('.bb-atc');

    function routeRoot() {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    }

    // The theme may be set to a drawer or to the notification popup.
    function cartUi() {
      return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    }

    /* Shopify applies a code to the session when this route is hit, which is
       what makes the saving show on the cart, in the drawer and at checkout. */
    function applyDiscount(code) {
      if (!code) return Promise.resolve();
      return fetch(routeRoot() + 'discount/' + encodeURIComponent(code), {
        method: 'GET',
        credentials: 'same-origin'
      }).catch(function () {});
    }

    function sectionsToRequest() {
      var ui = cartUi();
      var ids = [];
      if (ui && ui.dataset && ui.dataset.id) ids.push(ui.dataset.id);
      else if (ui) ids.push(ui.tagName.toLowerCase());
      ids.push('cart-icon-bubble');
      ids.push('cart-live-region-text');
      return ids.join(',');
    }
    /* The drawer is rendered with an empty-cart class when the page loads on
      an empty cart, and the theme's drawer script does not clear it after an
      add. Left on, it hides the header and collapses the new line to nothing,
       and the drawer then tries to focus an empty-cart box that is gone. */
    function clearEmptyState(ui) {
      if (!ui || ui.tagName.toLowerCase() !== 'cart-drawer') return;
      ui.classList.remove('is-empty');
      var items = ui.querySelector('cart-drawer-items');
      if (items) items.classList.remove('is-empty');
      var inner = ui.querySelector('.drawer__inner');
      if (inner) inner.classList.remove('is-empty');
    }
    function showCart(state) {
      var ui = cartUi();
      if (!ui) return false;
      try {
        if (typeof ui.renderContents === 'function') {
          clearEmptyState(ui);
          if (typeof ui.setActiveElement === 'function' && atc) ui.setActiveElement(atc);
          ui.renderContents(state);
          clearEmptyState(ui);
          return true;
        }
        if (typeof ui.open === 'function') {
          ui.open();
          return true;
        }
      } catch (err) { /* fall through to the plain redirect */ }
      return false;
    }

    function flash(message) {
      if (!message) return;
      var host = document.querySelector('.drawer__footer')
        || document.querySelector('#CartDrawer-Form')
        || document.querySelector('.cart-notification__links')
        || document.querySelector('.cart-notification__header');
      if (!host) return;
      var old = host.querySelector('.bigme-cart-flash');
      if (old) old.remove();
      var p = document.createElement('p');
      p.className = 'bigme-cart-flash';
      p.setAttribute('role', 'status');
      p.innerHTML = message;
      host.insertBefore(p, host.firstChild);
    }

    /* Every add-to-cart control on the page shows the same busy state, so a
       customer who tapped the sticky bar can see that something is happening. */
    function setAdding(busy) {
      document.dispatchEvent(new CustomEvent('bigme:adding', { detail: { busy: busy } }));
    }

    form.addEventListener('submit', function (e) {
      // Without fetch there is still the ordinary form post, which carries a
      // return_to that applies the code the long way round.
      if (!window.fetch || !window.FormData) return;
      e.preventDefault();

      if (atc) {
        atc.disabled = true;
        atc.classList.add('is-loading');
      }
      setAdding(true);

      var code = opts.discountCode();
      var body = new FormData(form);
      body.append('sections', sectionsToRequest());
      body.append('sections_url', window.location.pathname);
      // The non-JS fallback is not wanted once we are handling this ourselves.
      body.delete('return_to');

      applyDiscount(code)
        .then(function () {
          return fetch(routeRoot() + 'cart/add.js', {
            method: 'POST',
            headers: { Accept: 'application/javascript' },
            credentials: 'same-origin',
            body: body
          });
        })
        .then(function (res) { return res.json(); })
        .then(function (state) {
          if (state.status) throw new Error(state.description || state.message || 'add failed');

          // The theme's own cart icon section comes back in the response.
          document.dispatchEvent(new CustomEvent('bigme:cart-updated', { detail: {} }));

          if (!showCart(state)) {
            window.location.href = routeRoot() + 'cart';
            return;
          }
          if (code) flash(opts.discountMessage(code));
        })
        .catch(function () {
          // Anything unexpected: hand it back to the browser to post normally.
          form.submit();
        })
        .finally(function () {
          if (atc) {
            atc.disabled = false;
            atc.classList.remove('is-loading');
          }
          setAdding(false);
        });
    });
  }

  /* ---------------------------------------------------------
     Social proof rotator
     --------------------------------------------------------- */
  function initSocialProof(scope) {
    var rot = scope.querySelector('.sp-rot');
    if (!rot) return;
    var figures = [].slice.call(rot.children);
    if (figures.length < 2) {
      if (figures[0]) figures[0].classList.add('sp-on');
      return;
    }

    var i = 0, timer = null, resume = null;

    function paint() {
      figures.forEach(function (f, n) { f.classList.toggle('sp-on', n === i); });
    }
    function go(step) {
      i = (i + step + figures.length) % figures.length;
      paint();
    }
    function start() {
      clearInterval(timer);
      timer = setInterval(function () { go(1); }, 3000);
    }
    function manual(step) {
      go(step);
      if (reduceMotion) return;
      clearInterval(timer);
      clearTimeout(resume);
      resume = setTimeout(start, 4500);
    }

    var prev = scope.querySelector('.sp-nav.prev');
    var next = scope.querySelector('.sp-nav.next');
    if (prev) prev.addEventListener('click', function () { manual(-1); });
    if (next) next.addEventListener('click', function () { manual(1); });

    paint();
    if (!reduceMotion) start();
  }

  /* ---------------------------------------------------------
     Customer clips — a tap plays the clip in a player over the page
     --------------------------------------------------------- */
  function initClips(scope) {
    var dlg = scope.querySelector('[data-clip-player]');
    var clips = [].slice.call(scope.querySelectorAll('.sp-clip[data-clip]'));
    if (!dlg || !clips.length) return;
    var video = dlg.querySelector('video');
    var close = dlg.querySelector('.sp-player-close');
    if (!video) return;
    var modal = typeof dlg.showModal === 'function';
    var opener = null;

    // Stops the clip and lets go of it, so nothing keeps downloading.
    function release() {
      video.pause();
      video.removeAttribute('src');
      video.removeAttribute('poster');
      try { video.load(); } catch (err) {}
      if (opener) { try { opener.focus({ preventScroll: true }); } catch (err) {} opener = null; }
    }
    function shut() {
      if (modal) { if (dlg.open) dlg.close(); else release(); }
      else { dlg.removeAttribute('open'); release(); }
    }

    clips.forEach(function (clip) {
      clip.addEventListener('click', function () {
        var img = clip.querySelector('img');
        opener = clip;
        video.src = clip.getAttribute('data-clip');
        if (img && img.currentSrc) video.poster = img.currentSrc;
        if (modal) { if (!dlg.open) dlg.showModal(); }
        else dlg.setAttribute('open', '');
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
      });
    });

    if (close) close.addEventListener('click', shut);
    // Escape and form-less closes all end up here.
    dlg.addEventListener('close', release);
    // A tap on the dimmed backdrop (the dialog box itself, outside the video) closes it.
    dlg.addEventListener('click', function (e) { if (e.target === dlg) shut(); });
  }

  /* ---------------------------------------------------------
     Auto rails — a row of cards with a little of the next one showing
     at the end. It moves on by itself and loops back to the first card,
     holds still while it is touched, hovered or focused, and can be
     swiped with a finger, dragged with the mouse or scrolled with a
     trackpad. No scrollbar shows. The trust points and the
     certifications use it; their section settings arrive as data
     attributes on the row (data-auto-rail names the look):
       data-autoplay  "false" stops it moving by itself
       data-interval  seconds on each card
       data-drag      "false" turns off dragging with the mouse
       data-wheel     "true" lets a plain mouse wheel scroll the row
       data-arrows    "true" adds an arrow either side
     --------------------------------------------------------- */
  function initAutoRails(scope) {
    [].slice.call(scope.querySelectorAll('[data-auto-rail]')).forEach(function (rail) {
      if (rail.dataset.bmRail) return;
      rail.dataset.bmRail = '1';
      var slides = [].slice.call(rail.children);
      if (slides.length < 2) return;
      var opt = function (name) { return rail.getAttribute('data-' + name); };
      var autoplay = opt('autoplay') !== 'false' && !reduceMotion;
      var interval = Math.max(1500, (parseFloat(opt('interval')) || 3) * 1000);
      var dragOn = opt('drag') !== 'false';
      var wheelOn = opt('wheel') === 'true';
      var arrowsOn = opt('arrows') === 'true';
      var resumeTimer = null, settleTimer = null, snapTimer = null, held = false, visible = true;

      // A frame round the row: it carries the rule lines and, when they
      // are turned on, the arrows in gutters either side.
      var wrap = document.createElement('div');
      wrap.className = 'bm-rail-wrap' + (arrowsOn ? ' has-arrows' : '');
      wrap.setAttribute('data-rail', opt('auto-rail') || 'plain');
      rail.parentNode.insertBefore(wrap, rail);
      wrap.appendChild(rail);
      if (arrowsOn) {
        ['prev', 'next'].forEach(function (dir) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'bm-rail-arrow bm-rail-arrow--' + dir;
          b.setAttribute('aria-label', dir === 'prev' ? 'Previous' : 'Next');
          b.innerHTML = '<span aria-hidden="true">' + (dir === 'prev' ? '‹' : '›') + '</span>';
          b.addEventListener('click', function () { by(dir === 'prev' ? -1 : 1); });
          wrap.appendChild(b);
        });
      }

      function maxScroll() { return Math.max(0, rail.scrollWidth - rail.clientWidth); }
      // Where a card starts, measured the way scrollLeft is.
      function startOf(slide) { return slide.offsetLeft - slides[0].offsetLeft; }
      // The card the row is resting on (or nearest to).
      function current() {
        var best = 0, min = Infinity;
        slides.forEach(function (s, i) {
          var d = Math.abs(startOf(s) - rail.scrollLeft);
          if (d < min) { min = d; best = i; }
        });
        return best;
      }
      function go(left) {
        try { rail.scrollTo({ left: left, behavior: reduceMotion ? 'auto' : 'smooth' }); } catch (err) { rail.scrollLeft = left; }
      }
      // Lands on a card once a drag or a wheel lets go: a little way past a
      // card's edge (15%) is enough to carry on to it in the direction moved.
      // Snapping stays off until the row has arrived: switched back on any
      // earlier, the browser would pull the row to the nearest card first.
      function settle(dir) {
        var stepW = slides.length > 1 ? startOf(slides[1]) : rail.clientWidth;
        var at = stepW > 0 ? rail.scrollLeft / stepW : 0;
        var idx = dir > 0 ? Math.ceil(at - 0.15) : dir < 0 ? Math.floor(at + 0.15) : Math.round(at);
        idx = Math.max(0, Math.min(slides.length - 1, idx));
        go(Math.min(maxScroll(), startOf(slides[idx])));
        clearTimeout(snapTimer);
        snapTimer = setTimeout(function () { rail.classList.remove('is-busy'); }, 600);
      }
      // One card on, or back; past either end it wraps round.
      function by(dir) {
        var max = maxScroll();
        if (max < 4) return;
        if (dir > 0) {
          if (rail.scrollLeft >= max - 2) go(0);
          else go(Math.min(max, startOf(slides[Math.min(slides.length - 1, current() + 1)])));
        } else if (rail.scrollLeft <= 2) {
          go(max);
        } else {
          go(startOf(slides[Math.max(0, current() - 1)]));
        }
      }
      function hold() { held = true; clearTimeout(resumeTimer); }
      function release() {
        clearTimeout(resumeTimer);
        resumeTimer = setTimeout(function () { held = false; }, 2500);
      }
      // When every card fits there is nothing to move.
      function fit() { wrap.classList.toggle('is-static', maxScroll() < 4); }
      fit();
      window.addEventListener('resize', fit);
      window.addEventListener('load', fit);

      // Hold: a mouse over the row (or its arrows), a finger on it, focus in it.
      wrap.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') hold(); });
      wrap.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') release(); });
      wrap.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse') hold(); });
      ['pointerup', 'pointercancel'].forEach(function (ev) {
        wrap.addEventListener(ev, function (e) { if (e.pointerType !== 'mouse') release(); });
      });
      wrap.addEventListener('touchstart', hold, { passive: true });
      wrap.addEventListener('touchend', release, { passive: true });
      wrap.addEventListener('focusin', hold);
      wrap.addEventListener('focusout', release);

      // Drag with the mouse. A finger swipes natively; a press that barely
      // moves is still a click.
      if (dragOn) {
        rail.classList.add('is-draggable');
        var down = false, dragging = false, startX = 0, startLeft = 0, pid = null;
        rail.addEventListener('pointerdown', function (e) {
          if (e.pointerType !== 'mouse' || e.button !== 0) return;
          down = true; dragging = false; startX = e.clientX; startLeft = rail.scrollLeft; pid = e.pointerId;
        });
        rail.addEventListener('pointermove', function (e) {
          if (!down) return;
          var dx = e.clientX - startX;
          if (!dragging) {
            if (Math.abs(dx) < 6) return;
            dragging = true;
            rail.classList.add('is-busy', 'is-dragging');
            try { rail.setPointerCapture(pid); } catch (err) {}
          }
          rail.scrollLeft = startLeft - dx;
        });
        var end = function () {
          if (!down) return;
          down = false;
          if (!dragging) return;
          rail.classList.remove('is-dragging');
          try { rail.releasePointerCapture(pid); } catch (err) {}
          settle(rail.scrollLeft > startLeft ? 1 : rail.scrollLeft < startLeft ? -1 : 0);
          // The click that ends a drag is not a click on a card.
          setTimeout(function () { dragging = false; }, 0);
        };
        rail.addEventListener('pointerup', end);
        rail.addEventListener('pointercancel', end);
        rail.addEventListener('click', function (e) {
          if (dragging) { e.preventDefault(); e.stopPropagation(); }
        }, true);
        rail.addEventListener('dragstart', function (e) { e.preventDefault(); });
      }

      // A trackpad's sideways swipe scrolls the row natively. With the
      // setting on, a plain mouse wheel does too - until the row reaches
      // either end, where the page carries on scrolling as normal.
      if (wheelOn) {
        rail.addEventListener('wheel', function (e) {
          if (Math.abs(e.deltaX) >= Math.abs(e.deltaY)) return;
          var max = maxScroll();
          if ((rail.scrollLeft <= 0 && e.deltaY < 0) || (rail.scrollLeft >= max - 1 && e.deltaY > 0)) return;
          e.preventDefault();
          rail.classList.add('is-busy');
          rail.scrollLeft = Math.max(0, Math.min(max, rail.scrollLeft + e.deltaY));
          var wheelDir = e.deltaY > 0 ? 1 : -1;
          clearTimeout(settleTimer);
          settleTimer = setTimeout(function () { settle(wheelDir); }, 160);
        }, { passive: false });
      }

      // Only a row on screen moves.
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          visible = entries[entries.length - 1].isIntersecting;
        }, { threshold: 0.4 }).observe(rail);
      }
      if (autoplay) {
        setInterval(function () {
          if (held || !visible || document.hidden) return;
          by(1);
        }, interval);
      }
    });
  }

  /* ---------------------------------------------------------
     Marquees — drag to scrub, trackpad to scrub, tap to pause
     --------------------------------------------------------- */
  function initMarquees(root) {
    (root || document).querySelectorAll('.mq').forEach(function (mq) {
      if (mq.dataset.bmMq) return;
      mq.dataset.bmMq = '1';
      var down = false, sx = 0, sl = 0;
      mq.addEventListener('pointerdown', function (e) {
        down = true; sx = e.clientX; sl = mq.scrollLeft; mq.classList.add('dragging');
      });
      mq.addEventListener('pointermove', function (e) {
        if (!down) return;
        mq.scrollLeft = sl - (e.clientX - sx);
      });
      mq.addEventListener('pointerup', function (e) {
        var tap = down && Math.abs(e.clientX - sx) < 7;
        down = false;
        mq.classList.remove('dragging');
        if (tap && e.pointerType !== 'mouse') mq.classList.toggle('is-paused');
      });
      ['pointercancel', 'pointerleave'].forEach(function (t) {
        mq.addEventListener(t, function () { down = false; mq.classList.remove('dragging'); });
      });
      // Horizontal trackpad gestures scrub the marquee.
      mq.addEventListener('wheel', function (e) {
        if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
        e.preventDefault();
        mq.scrollLeft += e.deltaX;
      }, { passive: false });
    });
  }

  /* ---------------------------------------------------------
     Video carousel — auto-advance, drag, wheel, arrows
     --------------------------------------------------------- */
  function initVideoCarousel(scope) {
    var stage = scope.querySelector('.vstage');
    if (!stage) return;
    var slides = [].slice.call(stage.querySelectorAll('.vslide'));
    if (!slides.length) return;

    var fill = scope.querySelector('.vbar-fill');
    var autoplay = stage.getAttribute('data-autoplay') === 'true' && !reduceMotion;
    var interval = Math.max(1500, (parseFloat(stage.getAttribute('data-autoplay-speed')) || 4) * 1000);
    var wheelScroll = stage.getAttribute('data-wheel') === 'true';

    var idx = 0;
    var timer = null;
    var resumeTimer = null;
    var settleTimer = null;
    var hovered = false;
    var dragging = false;

    /* CSS scroll snapping and a scripted scroll fight each other: the snap
       engine keeps yanking the position back mid-animation, which is what made
       dragging and wheeling feel like it stuttered. Snapping is therefore
       switched off for as long as we are driving the scroll ourselves. */
    function busy(on) {
      stage.classList.toggle('is-busy', !!on);
    }

    function centreOf(el) {
      return el.offsetLeft + el.offsetWidth / 2 - stage.clientWidth / 2;
    }
    function maxScroll() {
      return Math.max(0, stage.scrollWidth - stage.clientWidth);
    }
    function nearest() {
      var best = 0, min = Infinity;
      slides.forEach(function (s, i) {
        var d = Math.abs(centreOf(s) - stage.scrollLeft);
        if (d < min) { min = d; best = i; }
      });
      return best;
    }
    function paint() {
      slides.forEach(function (s, i) {
        s.classList.toggle('is-active', i === idx);
        // A clip stops once its card is no longer the one in the middle.
        var v = i === idx ? null : s.querySelector('video');
        if (v && !v.paused) v.pause();
      });
      if (fill) fill.style.width = ((idx + 1) / slides.length * 100) + '%';
    }

    function goTo(i, smooth) {
      idx = clamp(i, 0, slides.length - 1);
      paint();
      var target = clamp(centreOf(slides[idx]), 0, maxScroll());
      if (Math.abs(stage.scrollLeft - target) < 1) {
        // Already there — but snapping still has to come back on.
        if (!dragging) busy(false);
        return;
      }

      busy(true);
      if (smooth === false || reduceMotion || typeof stage.scrollTo !== 'function') {
        stage.scrollLeft = target;
        settle();
        return;
      }
      // Native smooth scrolling stays in step with the browser's own
      // compositor instead of racing it from a rAF loop.
      try {
        stage.scrollTo({ left: target, behavior: 'smooth' });
      } catch (err) {
        stage.scrollLeft = target;
      }
      settle();
    }

    // Snapping comes back once the scroll has stopped moving.
    function settle() {
      clearTimeout(settleTimer);
      var last = stage.scrollLeft;
      settleTimer = setInterval(function () {
        if (Math.abs(stage.scrollLeft - last) < 1) {
          clearInterval(settleTimer);
          settleTimer = null;
          if (!dragging) busy(false);
        }
        last = stage.scrollLeft;
      }, 90);
    }

    /* ---- auto-advance ---- */
    function playing() {
      return slides.some(function (s) {
        var v = s.querySelector('video');
        return v && !v.paused && !v.ended;
      });
    }
    function start() {
      if (!autoplay) return;
      clearInterval(timer);
      timer = setInterval(function () {
        if (hovered || dragging || playing() || document.hidden) return;
        goTo(idx >= slides.length - 1 ? 0 : idx + 1);
      }, interval);
    }
    function stop() { clearInterval(timer); }
    function pauseThenResume() {
      if (!autoplay) return;
      stop();
      clearTimeout(resumeTimer);
      resumeTimer = setTimeout(start, Math.max(interval, 4000));
    }

    stage.addEventListener('pointerenter', function () { hovered = true; });
    stage.addEventListener('pointerleave', function () { hovered = false; });
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop(); else start();
    });

    /* ---- arrows ---- */
    scope.querySelectorAll('.vnav').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var dir = parseInt(btn.getAttribute('data-dir'), 10);
        var next = idx + dir;
        if (next < 0) next = slides.length - 1;
        if (next > slides.length - 1) next = 0;
        goTo(next);
        pauseThenResume();
      });
    });

    /* ---- the carousel's own scrolling keeps the active slide honest ---- */
    var scrollTimer;
    stage.addEventListener('scroll', function () {
      if (dragging) return;
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var n = nearest();
        if (n !== idx) { idx = n; paint(); }
      }, 120);
    }, { passive: true });

    /* ---- drag ----
       A press only becomes a drag once the pointer has really moved. Until
       then nothing is captured, so a tap still lands on the card it was on
       and plays that clip. */
    var startX = 0, startLeft = 0, moved = 0, pointerId = null, pressed = false;

    stage.addEventListener('pointerdown', function (e) {
      moved = 0;
      if (e.button !== undefined && e.button !== 0) return;
      // A playing clip's own controls (seek bar, volume) are not a drag.
      if (e.target.closest && e.target.closest('video')) return;
      pressed = true;
      startX = e.clientX;
      startLeft = stage.scrollLeft;
      pointerId = e.pointerId;
    });

    stage.addEventListener('pointermove', function (e) {
      if (!pressed) return;
      var dx = e.clientX - startX;
      moved = Math.max(moved, Math.abs(dx));
      if (!dragging) {
        if (moved <= 6) return;
        dragging = true;
        // Capture keeps the drag alive even if the pointer leaves the carousel.
        try { stage.setPointerCapture(pointerId); } catch (err) {}
        busy(true);
        stop();
        stage.classList.add('dragging');
      }
      stage.scrollLeft = clamp(startLeft - dx, 0, maxScroll());
    });

    function endDrag() {
      pressed = false;
      if (!dragging) return;
      dragging = false;
      stage.classList.remove('dragging');
      if (pointerId !== null) {
        try { stage.releasePointerCapture(pointerId); } catch (err) {}
        pointerId = null;
      }
      goTo(nearest());
      pauseThenResume();
    }
    ['pointerup', 'pointercancel'].forEach(function (ev) {
      stage.addEventListener(ev, endDrag);
    });
    // A click that came out of a drag must not open the clip.
    stage.addEventListener('click', function (e) {
      if (moved > 6) { e.preventDefault(); e.stopPropagation(); }
    }, true);

    /* ---- wheel and trackpad ----
       One gesture pauses the autoplay once, not on every tick. At either end
       the page keeps scrolling as normal so the carousel never traps you. */
    var wheelIdle = null;
    stage.addEventListener('wheel', function (e) {
      var horizontal = Math.abs(e.deltaX) > Math.abs(e.deltaY);
      if (!horizontal && !wheelScroll) return;
      var delta = horizontal ? e.deltaX : e.deltaY;
      var max = maxScroll();
      if ((stage.scrollLeft <= 0 && delta < 0) || (stage.scrollLeft >= max - 1 && delta > 0)) return;

      e.preventDefault();
      busy(true);
      stage.scrollLeft = clamp(stage.scrollLeft + delta, 0, max);

      if (!wheelIdle) stop();
      clearTimeout(wheelIdle);
      wheelIdle = setTimeout(function () {
        wheelIdle = null;
        goTo(nearest());
        pauseThenResume();
      }, 140);
    }, { passive: false });

    /* ---- keyboard ---- */
    stage.setAttribute('tabindex', '0');
    stage.setAttribute('role', 'region');
    stage.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      e.preventDefault();
      goTo(idx + (e.key === 'ArrowLeft' ? -1 : 1));
      pauseThenResume();
    });

    /* ---- play a clip, right there in its own card ----
       The video is only fetched on the first tap. A tap on a card at the side
       brings it to the middle and plays it there; any other clip stops. */
    function playIn(slide) {
      var src = slide.getAttribute('data-video');
      var art = slide.querySelector('.vcard-art');
      if (!src || !art) return;
      stop();
      clearTimeout(resumeTimer);
      var v = art.querySelector('video');
      if (!v) {
        v = document.createElement('video');
        v.setAttribute('playsinline', '');
        v.playsInline = true;
        v.controls = true;
        v.preload = 'auto';
        var poster = slide.getAttribute('data-poster');
        if (poster) v.poster = poster;
        v.src = src;
        // Once the clip finishes, the row may carry on by itself.
        v.addEventListener('ended', pauseThenResume);
        art.appendChild(v);
        art.classList.add('has-video');
      }
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    }

    slides.forEach(function (slide, i) {
      var card = slide.querySelector('.vcard');
      if (!card) return;
      card.addEventListener('click', function (e) {
        if (moved > 6) return;
        // Taps on the video's own controls are the video's business.
        if (e.target.closest && e.target.closest('video')) return;
        if (i !== idx) goTo(i);
        playIn(slide);
      });
    });

    requestAnimationFrame(function () {
      goTo(Math.min(Math.floor(slides.length / 2), slides.length - 1), false);
      start();
    });

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () { goTo(idx, false); }, 120);
    });
  }

  /* ---------------------------------------------------------
     Survey ring counters
     --------------------------------------------------------- */
  function initStats(scope) {
    var sec = scope.querySelector('.stats');
    if (!sec) return;
    var rows = [].slice.call(sec.querySelectorAll('.stat-row'));
    if (!rows.length) return;
    var C = 270.2;

    function paint(row, pct, n) {
      var arc = row.querySelector('.stat-arc');
      if (arc) arc.style.strokeDashoffset = C * (1 - pct / 100);
      var num = row.querySelector('.stat-num');
      if (num) num.textContent = n + '%';
    }
    function run(row, delay) {
      var el = row.querySelector('.stat-num');
      if (!el) return;
      var pct = parseInt(el.getAttribute('data-pct') || '', 10);
      if (isNaN(pct) || pct <= 0 || pct > 100) { paint(row, 0, 0); return; }
      if (reduceMotion) { paint(row, pct, pct); return; }
      setTimeout(function () {
        var t0 = performance.now(), dur = 1400;
        (function tick(now) {
          var p = Math.min(1, (now - t0) / dur);
          var e = 1 - Math.pow(1 - p, 3);
          paint(row, pct * e, Math.round(pct * e));
          if (p < 1) requestAnimationFrame(tick);
          else paint(row, pct, pct);
        })(t0);
      }, delay);
    }

    var fired = false;
    function runAll() {
      if (fired) return;
      fired = true;
      rows.forEach(function (r, i) { run(r, i * 150); });
    }

    if (!('IntersectionObserver' in window)) { runAll(); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.intersectionRatio < 0.4) return;
        io.disconnect();
        runAll();
      });
    }, { threshold: [0, 0.4, 1] });
    io.observe(sec);
    // Never leave the rings empty if the observer does not fire.
    setTimeout(function () {
      if (!fired && sec.getBoundingClientRect().top < window.innerHeight) runAll();
    }, 1500);
  }

  /* ---------------------------------------------------------
     Certification band reveal
     --------------------------------------------------------- */
  function initCertBand(scope) {
    var row = scope.querySelector('.cband-row');
    if (!row) return;

    /* With more badges than fit on a line the row wraps, and a divider can
       end up dangling at the end of a line. A divider stays only while the
       badges either side of it share a line. */
    var dividers = [].slice.call(row.querySelectorAll('.cband-div'));
    function trimDividers() {
      dividers.forEach(function (d) { d.classList.remove('is-off'); });
      // Hiding a divider can pull the next badge up a line, so look again.
      for (var pass = 0; pass < 3; pass++) {
        var changed = false;
        dividers.forEach(function (d) {
          if (getComputedStyle(d).display === 'none') return;
          var a = d.previousElementSibling;
          var b = d.nextElementSibling;
          if (!a || !b) return;
          // Badges on one line share a centre line (the row centres them);
          // their tops can differ when one has a logo and one does not.
          var ra = a.getBoundingClientRect();
          var rb = b.getBoundingClientRect();
          var off = Math.abs((ra.top + ra.height / 2) - (rb.top + rb.height / 2)) > 8;
          if (off) { d.classList.add('is-off'); changed = true; }
        });
        if (!changed) break;
      }
    }
    if (dividers.length) {
      trimDividers();
      window.addEventListener('resize', trimDividers);
    }

    if (reduceMotion || !('IntersectionObserver' in window)) {
      row.classList.add('is-ready');
      return;
    }
    row.classList.add('pre');
    var done = false;
    function reveal() {
      if (done) return;
      done = true;
      row.classList.remove('pre');
      row.classList.add('in');
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { reveal(); io.disconnect(); }
      });
    }, { threshold: 0.35 });
    io.observe(row);
    // Failsafe: the band must never stay invisible.
    setTimeout(function () {
      if (!done && row.getBoundingClientRect().top < window.innerHeight * 1.5) reveal();
    }, 1200);
    setTimeout(reveal, 6000);
  }

  /* ---------------------------------------------------------
     Daily timeline — the marker drives everything
     --------------------------------------------------------- */
  function initTimeline(scope) {
    var pin = scope.querySelector('.dt-pin');
    var sec = scope.querySelector('.dt');
    var list = scope.querySelector('.dt-list');
    if (!pin || !sec || !list) return;

    var inner = sec.querySelector('.dt-inner');
    var fill = sec.querySelector('.dt-rail-fill');
    var mFill = sec.querySelector('.dt-mrail-fill');
    var mDots = [].slice.call(sec.querySelectorAll('.dt-mdots i'));
    var plots = [].slice.call(sec.querySelectorAll('.dt-plot'));
    var stops = [].slice.call(list.querySelectorAll('.dt-stop'));
    if (!plots.length || !stops.length) return;

    var wantPin = pin.getAttribute('data-pin') !== 'false';
    var cardsSpacing = pin.getAttribute('data-spacing') === 'cards';
    var keyIndex = -1;
    stops.forEach(function (s, i) { if (s.classList.contains('is-key')) keyIndex = i; });
    mDots.forEach(function (d, i) { if (i === keyIndex) d.classList.add('is-key'); });

    /* Sticky only works when no ancestor clips or scrolls. If one does — or the
       content is taller than the viewport, or the merchant switched the effect
       off — the section renders as an ordinary block instead of a tall gap. */
    var narrowQuery = window.matchMedia ? window.matchMedia('(max-width:1023px)') : null;
    function narrow() { return narrowQuery ? narrowQuery.matches : window.innerWidth < 1024; }

    /* True once the cards are a horizontal scroller the customer drives. */
    function swipeMode() {
      return pin.classList.contains('is-static') && list.scrollWidth > list.clientWidth + 4;
    }

    /* "Over each card" spacing applies while every card is on screen in one
       row. One card at a time (phones) the dots stay evenly spaced along
       the curve, the way the marker walks from card to card. */
    function overCards() {
      if (!cardsSpacing || stops.length < 2) return false;
      if (pin.classList.contains('is-track') && !pin.classList.contains('is-static')) return false;
      if (list.scrollWidth > list.clientWidth + 4) return false;
      var a = stops[0].getBoundingClientRect();
      var b = stops[stops.length - 1].getBoundingClientRect();
      return Math.abs(a.top - b.top) < 2 && b.left >= a.right;
    }

    function stickyBlocked() {
      var n = pin.parentElement;
      while (n && n !== document.body && n !== document.documentElement) {
        var s = getComputedStyle(n);
        if (/(hidden|clip|auto|scroll)/.test(s.overflowX) || /(hidden|clip|auto|scroll)/.test(s.overflowY)) return true;
        n = n.parentElement;
      }
      var b = getComputedStyle(document.body);
      var h = getComputedStyle(document.documentElement);
      return /(hidden|clip)/.test(b.overflowX + b.overflowY + h.overflowX + h.overflowY);
    }

    /* The store header stays stuck to the top of the screen, so the pinned
       panel starts below it instead of sliding underneath. Measured from the
       header itself (the floating pill sits a little below its section's top). */
    function headerOffset() {
      var h = document.querySelector('.shopify-section-header-sticky');
      if (!h) return 0;
      var pos = getComputedStyle(h).position;
      if (pos !== 'sticky' && pos !== 'fixed') return 0;
      var visible = h.querySelector('.header') || h;
      var bottom = visible.getBoundingClientRect().bottom - h.getBoundingClientRect().top;
      return Math.max(0, Math.round(bottom));
    }

    var TIERS = ['dt-fit-1', 'dt-fit-2', 'dt-fit-3'];
    function setTier(n) {
      TIERS.forEach(function (c, i) { pin.classList.toggle(c, i < n); });
    }

    /* Does the panel, as currently laid out, fit the space the pin gives it? */
    /* The height the pinned panel can use: the screen below the header and
       above the sticky add-to-cart bar (its height is --dt-bar, set in CSS
       only while the bar is on the page). */
    function room() {
      var vh = Math.min(window.innerHeight, document.documentElement.clientHeight || window.innerHeight);
      var bar = parseFloat(getComputedStyle(pin).getPropertyValue('--dt-bar')) || 0;
      return vh - headerOffset() - bar;
    }

    function fits() {
      return sec.offsetHeight <= room() + 1;
    }

    /* The panel is as tall as its own content, so the section meets its
       neighbours with the same gap as every other section. While pinned it
       sits in the middle of the room between the header and the bar. */
    function centrePanel(isStatic) {
      var stick = pin.querySelector('.dt-stick');
      if (!stick) return;
      if (isStatic) { pin.style.removeProperty('--dt-stick-top'); return; }
      var slack = Math.max(0, room() - stick.offsetHeight);
      pin.style.setProperty('--dt-stick-top', Math.round(headerOffset() + slack / 2) + 'px');
    }

    /* The section pins on every screen: wide screens show all the stops and
       the page scroll walks the marker across them; narrow screens show one
       card at a time and the scroll slides the row along. When the panel is
       taller than the screen it steps down through tighter layouts (no note,
       smaller chart, shorter pictures, then none) rather than give up the
       effect. It renders as an ordinary block only when it cannot pin at all:
       the effect is off, motion is reduced, an ancestor breaks sticky, or even
       the tightest layout will not fit. */
    function layout() {
      pin.style.setProperty('--dt-top', headerOffset() + 'px');
      var canPin = wantPin && !reduceMotion && !stickyBlocked();
      var fitted = false;
      pin.classList.remove('is-static');
      pin.classList.toggle('is-track', canPin && narrow());
      if (canPin) {
        for (var t = 0; t <= TIERS.length; t++) {
          setTier(t);
          if (fits()) { fitted = true; break; }
        }
      }
      if (!fitted) setTier(0);
      var isStatic = !canPin || !fitted;
      pin.classList.toggle('is-static', isStatic);
      pin.classList.toggle('is-track', !isStatic && narrow());
      if (isStatic) list.style.removeProperty('--dt-shift');
      centrePanel(isStatic);
      // The chart may have changed size: measure the curve afresh.
      lengthMaps = null;
      placeRail();
      return isStatic;
    }

    function finish() {
      plots.forEach(function (p) {
        var c = p.querySelector('.dt-calm');
        if (c) { c.style.strokeDasharray = 'none'; c.style.strokeDashoffset = '0'; }
        var r = p.querySelector('.dt-pill-rect');
        if (r) r.setAttribute('transform', 'scale(1,1)');
        var m = p.querySelector('.dt-marker');
        if (m) m.style.opacity = 0;
      });
      if (fill) fill.style.transform = 'scaleX(1)';
      if (mFill) mFill.style.transform = 'scaleX(1)';
      stops.forEach(function (st) { st.classList.add('is-lit'); });
      mDots.forEach(function (d) { d.classList.add('is-lit'); });
    }

    layout();
    // Without SVG geometry there is nothing to scrub, so show the end state.
    var probe = plots[0].querySelector('.dt-calm');
    if (reduceMotion || !probe || typeof probe.getTotalLength !== 'function') {
      finish();
      // Nothing animates, but the rail still follows the width.
      window.addEventListener('resize', function () { lengthMaps = null; layout(); });
      return;
    }

    var raf = 0, lit = [], activeIdx = -1, pulsed = false;
    var SPAN = 0.88, PILL_GAIN = 2.364;

    function activePlot() {
      for (var i = 0; i < plots.length; i++) if (plots[i].offsetParent !== null) return plots[i];
      return plots[0];
    }

    function toScreen(ctm, pt) {
      if (window.DOMPoint) return new DOMPoint(pt.x, pt.y).matrixTransform(ctm);
      return { x: ctm.a * pt.x + ctm.c * pt.y + ctm.e, y: ctm.b * pt.x + ctm.d * pt.y + ctm.f };
    }

    /* Walk the curve in screen space so the drawn tip and the marker share a
       ruler. Cached per plot and rebuilt whenever the layout changes. */
    // Declared, not built, here: layout() can run before this statement
    // does, so the map is created on first use instead.
    var lengthMaps;

    /* Where the chart's drawing is on screen right now. The map below is kept
       relative to it, so scrolling the page never leaves the marker behind. */
    function svgBox(calm) {
      var svg = calm.ownerSVGElement || calm;
      return svg.getBoundingClientRect();
    }

    function lengthMap(calm) {
      if (!lengthMaps) lengthMaps = new WeakMap();
      var cached = lengthMaps.get(calm);
      var org = svgBox(calm);
      if (cached && Math.abs(cached.width - org.width) < 0.5 && Math.abs(cached.height - org.height) < 0.5) return cached;

      var ctm = calm.getScreenCTM && calm.getScreenCTM();
      var userLen = calm.getTotalLength();
      if (!ctm || !userLen || !org.width) return null;

      var STEPS = 160;
      var pts = [];
      var acc = 0;
      var prev = null;
      for (var i = 0; i <= STEPS; i++) {
        var u = userLen * i / STEPS;
        var sp = toScreen(ctm, calm.getPointAtLength(u));
        if (prev) acc += Math.sqrt(Math.pow(sp.x - prev.x, 2) + Math.pow(sp.y - prev.y, 2));
        pts.push({ u: u, s: acc, x: sp.x - org.left, y: sp.y - org.top });
        prev = sp;
      }

      var map = { pts: pts, screenLen: acc, userLen: userLen, width: org.width, height: org.height };
      lengthMaps.set(calm, map);
      return map;
    }

    /* The point p of the way along the curve, measured as it looks on screen,
       relative to the drawing's top-left corner. */
    function pointAt(map, p) {
      var target = map.screenLen * clamp(p, 0, 1);
      var pts = map.pts;
      for (var i = 1; i < pts.length; i++) {
        if (pts[i].s >= target) {
          var a = pts[i - 1], b = pts[i];
          var span = b.s - a.s;
          var t = span > 0 ? (target - a.s) / span : 0;
          return { x: a.x + (b.x - a.x) * t, y: a.y + (b.y - a.y) * t };
        }
      }
      return pts[pts.length - 1];
    }

    /* The rail, the axis labels and the dots share one span: the drawn curve,
       first point to last. The markup places each dot at its time as a share
       of that span (--at); this measures where the curve really starts and
       ends on screen, so a dot sits under the moment it stands for. */
    function placeRail() {
      if (!inner) return;
      // Over each card: while the cards sit side by side, the rail runs from
      // the middle of the first card to the middle of the last, so with the
      // dots spaced evenly each one lands right over its own card.
      if (overCards()) {
        var ib = inner.getBoundingClientRect();
        var fb = stops[0].getBoundingClientRect();
        var lb = stops[stops.length - 1].getBoundingClientRect();
        if (ib.width) {
          inner.style.setProperty('--dt-l', clamp((fb.left + fb.width / 2 - ib.left) / ib.width, 0, 0.5) * 100 + '%');
          inner.style.setProperty('--dt-r', clamp((ib.right - (lb.left + lb.width / 2)) / ib.width, 0, 0.5) * 100 + '%');
          return;
        }
      }
      var plot = activePlot();
      var calm = plot && plot.querySelector('.dt-calm');
      if (!calm || typeof calm.getTotalLength !== 'function') return;
      var map = lengthMap(calm);
      var box = inner.getBoundingClientRect();
      if (!map || !box.width) return;
      var org = svgBox(calm);
      var x0 = org.left + map.pts[0].x;
      var x1 = org.left + map.pts[map.pts.length - 1].x;
      if (x1 - x0 < 10) return;
      // Shares of the width rather than pixels, so a resize the script misses
      // still leaves everything in proportion.
      inner.style.setProperty('--dt-l', clamp((x0 - box.left) / box.width, 0, 0.5) * 100 + '%');
      inner.style.setProperty('--dt-r', clamp((box.right - x1) / box.width, 0, 0.5) * 100 + '%');
    }

    /* How far along the curve (0-1) the point straight above x lies, with x
       measured from the drawing's left edge. */
    function pAtX(map, x) {
      var pts = map.pts;
      if (x <= pts[0].x) return 0;
      for (var i = 1; i < pts.length; i++) {
        if (pts[i].x >= x) {
          var a = pts[i - 1], b = pts[i];
          var t = b.x > a.x ? (x - a.x) / (b.x - a.x) : 0;
          return clamp((a.s + (b.s - a.s) * t) / (map.screenLen || 1), 0, 1);
        }
      }
      return 1;
    }

    /* Narrow screens show one card at a time, so there the position is an
       index along the row: 1.5 is half way from the second card to the third.
       The marker rests on that card's dot and slides between dots with it. */
    function xAtIndex(pos) {
      var xs = targets();
      pos = clamp(pos, 0, xs.length - 1);
      var a = Math.floor(pos);
      var b = Math.min(xs.length - 1, a + 1);
      return xs[a] + (xs[b] - xs[a]) * (pos - a);
    }

    /* Swiping (the unpinned fallback): the row's own scroll is the position. */
    function swipeIndex() {
      var span = list.scrollWidth - list.clientWidth;
      var frac = span > 0 ? clamp(list.scrollLeft / span, 0, 1) : 0;
      return frac * (stops.length - 1);
    }

    /* Pinned on a narrow screen, each card rests in the middle for a stretch
       of scroll before the next one slides in, so wherever the customer stops
       scrolling a card sits centred rather than half way between two. */
    function dwell(raw) {
      var last = stops.length - 1;
      if (raw >= last) return last;
      var k = Math.floor(raw);
      var u = clamp((raw - k - 0.28) / 0.44, 0, 1);
      return k + u * u * (3 - 2 * u);
    }

    /* Pinned on a narrow screen: the page scroll slides the row so the card
       at `pos` sits in the middle. */
    function slideTrack(pos) {
      pos = clamp(pos, 0, stops.length - 1);
      var a = Math.floor(pos);
      var b = Math.min(stops.length - 1, a + 1);
      var left = stops[a].offsetLeft + (stops[b].offsetLeft - stops[a].offsetLeft) * (pos - a);
      list.style.setProperty('--dt-shift', (stops[0].offsetLeft - left).toFixed(2) + 'px');
    }

    function progress() {
      var r = pin.getBoundingClientRect();
      if (pin.classList.contains('is-static')) {
        // Driven by the block crossing the viewport rather than by a pin.
        // Measured from the panel itself, and held at zero until it is properly
        // on screen — otherwise the line is already part drawn the moment the
        // section appears, which reads as a bug rather than an animation.
        var ir = inner ? inner.getBoundingClientRect() : r;
        var start = window.innerHeight * 0.62;
        var end = -ir.height + window.innerHeight * 0.55;
        if (start === end) return 0;
        return clamp((start - ir.top) / (start - end), 0, 1);
      }
      // Pinned: the panel sticks below the header, so the scrub starts when
      // the section reaches that line and ends when the pin runs out.
      // The pin's own padding sits outside the sticky range, so it is taken
      // off both ends: 0 the moment the panel sticks, 1 the moment it lets go.
      var stick = pin.querySelector('.dt-stick');
      var top0 = stick ? parseFloat(getComputedStyle(stick).top) || 0 : 0;
      var pcs = getComputedStyle(pin);
      var padTop = parseFloat(pcs.paddingTop) || 0;
      var padBottom = parseFloat(pcs.paddingBottom) || 0;
      var travel = r.height - padTop - padBottom - (stick ? stick.offsetHeight : window.innerHeight);
      if (travel <= 0) return r.top + padTop <= top0 ? 1 : 0;
      return clamp((top0 - padTop - r.top) / travel, 0, 1);
    }

    /* Screen-x of each stop on the rail: its dot, placed at the stop's time.
       Without the rail, the middle of each card. */
    function targets() {
      var useDots = mDots.length && mDots[0].offsetParent !== null;
      var els = useDots ? mDots : stops;
      return els.map(function (el) {
        var r = el.getBoundingClientRect();
        return r.left + r.width / 2;
      });
    }

    function railBox() {
      var useDots = mFill && mFill.offsetParent !== null;
      var el = useDots ? mFill.parentElement : (fill ? fill.parentElement : list);
      return el ? el.getBoundingClientRect() : list.getBoundingClientRect();
    }

    function draw() {
      raf = 0;
      var plot = activePlot();
      var calm = plot.querySelector('.dt-calm');
      var rect = plot.querySelector('.dt-pill-rect');
      var marker = plot.querySelector('.dt-marker');
      if (!calm) return;

      var map = lengthMap(calm);
      if (!map) return;
      var org = svgBox(calm);
      // Three ways to drive it: wide and pinned, the page scroll moves the
      // marker along the curve; narrow and pinned, the page scroll slides the
      // row of cards; unpinned on a narrow screen, the customer swipes the row.
      // In the two narrow modes the position is a card index.
      var track = pin.classList.contains('is-track') && !pin.classList.contains('is-static');
      var indexed = track || swipeMode();
      var pos = 0;
      var p;
      if (indexed) {
        pos = track ? dwell(clamp(progress() / SPAN, 0, 1) * (stops.length - 1)) : swipeIndex();
        if (track) slideTrack(pos);
        p = pAtX(map, xAtIndex(pos) - org.left);
      } else {
        p = clamp(progress() / SPAN, 0, 1);
      }

      // A non-scaling stroke measures its dashes on screen, so the dash length
      // is the screen length — the same ruler the marker is placed with.
      calm.style.strokeDasharray = map.screenLen;
      calm.style.strokeDashoffset = map.screenLen * (1 - p);
      // Card by card, the first card sits at the very start of the curve, so
      // the pill line is shown whole: the chart is never an empty frame, and
      // the product's line grows against it card by card.
      if (rect) rect.setAttribute('transform', 'scale(' + (indexed ? 1 : Math.min(1, p * PILL_GAIN)) + ',1)');
      var swiping = indexed;

      // Where the marker actually is on screen — the single source of truth.
      var markerX = null;
      if (marker) {
        var sp = pointAt(map, p);
        var sx = org.left + sp.x;
        var sy = org.top + sp.y;
        markerX = sx;
        var box = plot.getBoundingClientRect();
        // The marker is "now": while swiping it always marks the card's time.
        marker.style.opacity = swiping || (p > 0.005 && p < 0.995) ? 1 : 0;
        marker.style.transform = 'translate3d(' + (sx - box.left) + 'px,' + (sy - box.top) + 'px,0)';
        var rb = railBox();
        marker.style.setProperty('--dt-guide', Math.max(0, rb.top + rb.height / 2 - sy) + 'px');
      }

      // The rail fills to exactly where the marker is, so the two never disagree.
      var rbox = railBox();
      var railP = markerX === null ? p : clamp((markerX - rbox.left) / (rbox.width || 1), 0, 1);
      if (fill) fill.style.transform = 'scaleX(' + railP + ')';
      if (mFill) mFill.style.transform = 'scaleX(' + railP + ')';

      // A stop lights when the marker reaches its dot (a pixel of slack, so a
      // marker resting exactly on a dot counts as there). Card by card, a stop
      // lights once its card is more than half way into the middle.
      var xs = targets();
      var newActive = -1;
      var near = Math.round(pos);
      stops.forEach(function (st, i) {
        var on = indexed
          ? i <= near
          : markerX === null
            ? p >= (i + 0.5) / stops.length
            : markerX >= xs[i] - 1;
        if (on) newActive = i;
        if (on !== !!lit[i]) {
          lit[i] = on;
          st.classList.toggle('is-lit', on);
          if (mDots[i]) mDots[i].classList.toggle('is-lit', on);
          if (on) {
            st.classList.add('is-bounce');
            setTimeout(function () { st.classList.remove('is-bounce'); }, 240);
            if (i === keyIndex && !pulsed && marker) {
              pulsed = true;
              marker.classList.add('is-pulse');
              setTimeout(function () { marker.classList.remove('is-pulse'); }, 700);
            }
          } else if (i === keyIndex) {
            pulsed = false;
          }
        }
      });

      if (newActive !== activeIdx) {
        activeIdx = newActive;
        stops.forEach(function (st, i) { st.classList.toggle('is-active', i === activeIdx); });
        mDots.forEach(function (d, i) { d.classList.toggle('is-active', i === activeIdx); });
        // Only follow the marker when the marker is the one leading. While the
        // customer is swiping, the carousel is the input, so moving it here
        // would fight the finger that just moved it.
        if (activeIdx >= 0 && !indexed && list.scrollWidth > list.clientWidth + 4) {
          var card = stops[activeIdx];
          var want = card.offsetLeft - (list.clientWidth - card.offsetWidth) / 2;
          list.scrollTo({ left: want, behavior: 'smooth' });
        }
      }
    }

    function tick() { if (!raf) raf = requestAnimationFrame(draw); }
    window.addEventListener('scroll', tick, { passive: true });
    list.addEventListener('scroll', tick, { passive: true });
    if (narrowQuery && narrowQuery.addEventListener) {
      narrowQuery.addEventListener('change', function () { lengthMaps = null; layout(); tick(); });
    }
    window.addEventListener('resize', function () {
      lengthMaps = null;
      layout();
      tick();
    });
    // Fonts and images change the height; re-measure once they settle.
    setTimeout(function () { layout(); tick(); }, 400);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () { layout(); tick(); });
    }
    tick();
  }

  /* ---------------------------------------------------------
     Before / after comparison slider
     --------------------------------------------------------- */
  function initBeforeAfter(scope) {
    var stage = scope.querySelector('.ba-stage');
    if (!stage) return;
    var after = stage.querySelector('.ba-after');
    var handle = stage.querySelector('.ba-handle');
    if (!after || !handle) return;
    var dragging = false;
    var pct = 50;

    function apply() {
      after.style.clipPath = 'inset(0 0 0 ' + pct + '%)';
      handle.style.left = pct + '%';
      handle.setAttribute('aria-valuenow', Math.round(pct));
    }
    function setPos(clientX) {
      var r = stage.getBoundingClientRect();
      pct = clamp(((clientX - r.left) / r.width) * 100, 0, 100);
      apply();
    }

    stage.addEventListener('pointerdown', function (e) {
      dragging = true;
      try { stage.setPointerCapture(e.pointerId); } catch (err) {}
      setPos(e.clientX);
    });
    stage.addEventListener('pointermove', function (e) { if (dragging) setPos(e.clientX); });
    stage.addEventListener('pointerup', function () { dragging = false; });
    stage.addEventListener('pointercancel', function () { dragging = false; });

    handle.tabIndex = 0;
    handle.setAttribute('role', 'slider');
    handle.setAttribute('aria-label', 'Compare before and after');
    handle.setAttribute('aria-valuemin', '0');
    handle.setAttribute('aria-valuemax', '100');
    handle.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      e.preventDefault();
      pct = clamp(pct + (e.key === 'ArrowLeft' ? -4 : 4), 0, 100);
      apply();
    });
    apply();
  }

  /* ---------------------------------------------------------
     FAQ accordion — height animated, one open at a time
     --------------------------------------------------------- */
  function initFaq(scope) {
    scope.querySelectorAll('.faq-list').forEach(function (list) {
      if (list.dataset.bmFaq) return;
      list.dataset.bmFaq = '1';
      var single = list.getAttribute('data-single') !== 'false';

      list.addEventListener('click', function (e) {
        var q = e.target.closest('.faq-q');
        if (!q) return;
        var item = q.closest('.faq-item');
        var wasOpen = item.classList.contains('open');

        if (single) {
          list.querySelectorAll('.faq-item.open').forEach(function (it) {
            if (it === item) return;
            it.classList.remove('open');
            var b = it.querySelector('.faq-q');
            if (b) b.setAttribute('aria-expanded', 'false');
          });
        }
        item.classList.toggle('open', !wasOpen);
        q.setAttribute('aria-expanded', String(!wasOpen));
      });
    });
  }

  /* ---------------------------------------------------------
     Sticky add-to-cart bar
     --------------------------------------------------------- */
  function initSticky(scope) {
    var sticky = scope.querySelector('.sticky');
    if (!sticky) return;
    document.body.classList.add('bigme-has-sticky');

    var total = sticky.querySelector('[data-sticky-total]');
    var label = sticky.querySelector('[data-sticky-label]');
    var button = sticky.querySelector('.atc');

    document.addEventListener('bigme:total', function (e) {
      if (total) total.textContent = e.detail.total ? '— ' + e.detail.total : '';
      if (label && e.detail.label) label.textContent = e.detail.label;
      if (button) button.disabled = e.detail.available === false;
    });

    var anchor = document.querySelector('.gal-main') || document.getElementById('bigme-buy');
    if (anchor) {
      window.addEventListener('scroll', function () {
        sticky.classList.toggle('show', anchor.getBoundingClientRect().bottom < 0);
      }, { passive: true });
    }

    if (button) {
      // The bar has no form of its own; it submits the one in the buy box and
      // then follows that request's busy state.
      var soldOut = false;
      document.addEventListener('bigme:total', function (e) {
        if (e.detail && e.detail.available === false) soldOut = true;
        else if (e.detail) soldOut = false;
      });
      document.addEventListener('bigme:adding', function (e) {
        var busy = !!(e.detail && e.detail.busy);
        button.classList.toggle('is-loading', busy);
        button.disabled = busy || soldOut;
        button.setAttribute('aria-busy', busy ? 'true' : 'false');
      });
      button.addEventListener('click', function () {
        var form = document.getElementById('bigme-buy-form');
        if (!form) return;
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.submit();
      });
    }
  }

  /* ---------------------------------------------------------
     Supplement buy box: "Read more" and the delivery estimate
     --------------------------------------------------------- */
  function initSupplement(scope) {
    var desc = scope.querySelector('[data-desc]');
    if (desc) {
      var body = desc.querySelector('[data-desc-body]');
      var more = desc.querySelector('[data-desc-more]');
      if (body && more) {
        // A description short enough to show whole has nothing to reveal.
        // The page's own description folds at a fixed point instead: the
        // part after its first paragraph.
        var rest = desc.querySelector('[data-desc-rest]');
        var check = function () {
          if (desc.classList.contains('is-open')) return;
          more.hidden = rest ? false : body.scrollHeight <= body.clientHeight + 2;
        };
        check();
        window.addEventListener('load', check);
        window.addEventListener('resize', check);
        more.addEventListener('click', function () {
          var open = desc.classList.toggle('is-open');
          more.textContent = more.getAttribute(open ? 'data-less' : 'data-more');
          more.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      }
    }

    // Dates are worked out on the customer's own clock: the server's copy
    // can be a cached page from an earlier day.
    var track = scope.querySelector('[data-track]');
    if (track) {
      var DAY = 86400000;
      var now = new Date();
      var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      var fmt = function (d) { return d.getDate() + ' ' + MONTHS[d.getMonth()]; };
      var at = function (n) { return new Date(now.getTime() + n * DAY); };
      var num = function (name) { return parseInt(track.getAttribute(name), 10) || 0; };
      var ship = num('data-ship');
      var min = num('data-min');
      var max = Math.max(min, num('data-max'));
      var put = function (key, text) {
        var el = track.querySelector('[data-track-date="' + key + '"]');
        if (el) el.textContent = text;
      };
      put('order', fmt(now));
      put('ship', fmt(at(ship)));
      put('deliver', min === max ? fmt(at(min)) : fmt(at(min)) + ' – ' + fmt(at(max)));
    }
  }

  /* ---------------------------------------------------------
     Actives list: one ingredient opens at a time
     --------------------------------------------------------- */
  function initActives(scope) {
    var list = scope.querySelector('[data-acts]');
    if (!list) return;
    var single = list.getAttribute('data-single') !== 'false';
    var items = [].slice.call(list.querySelectorAll('.act'));
    function set(item, open) {
      item.classList.toggle('open', open);
      var q = item.querySelector('.act-q');
      if (q) q.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    items.forEach(function (item) {
      var q = item.querySelector('.act-q');
      if (!q) return;
      q.addEventListener('click', function () {
        var open = !item.classList.contains('open');
        if (open && single) items.forEach(function (other) { if (other !== item) set(other, false); });
        set(item, open);
      });
    });
    // Theme Editor: selecting an active in the sidebar opens it.
    scope.addEventListener('shopify:block:select', function (e) {
      var item = e.target.closest ? e.target.closest('.act') : null;
      if (!item) return;
      if (single) items.forEach(function (other) { if (other !== item) set(other, false); });
      set(item, true);
    });
  }

  /* ---------------------------------------------------------
     Info tabs: tabs and dots switch one card
     --------------------------------------------------------- */
  function initTabs(scope) {
    var root = scope.querySelector('[data-tabs]');
    if (!root) return;
    var tabs = [].slice.call(root.querySelectorAll('.wwh-tab'));
    var slides = [].slice.call(root.querySelectorAll('.wwh-slide'));
    var dots = [].slice.call(root.querySelectorAll('.wwh-dot'));
    if (!tabs.length) return;
    var current = 0;
    function show(i, focus) {
      i = (i + tabs.length) % tabs.length;
      current = i;
      tabs.forEach(function (t, k) {
        var on = k === i;
        t.classList.toggle('active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.setAttribute('tabindex', on ? '0' : '-1');
      });
      slides.forEach(function (s, k) {
        var on = k === i;
        s.classList.toggle('active', on);
        s.hidden = !on;
      });
      dots.forEach(function (d, k) { d.classList.toggle('active', k === i); });
      if (focus) tabs[i].focus();
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { show(i); });
      // Arrow keys move along the tab row, as a tab list should.
      t.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); show(current + 1, true); }
        else if (e.key === 'ArrowLeft') { e.preventDefault(); show(current - 1, true); }
        else if (e.key === 'Home') { e.preventDefault(); show(0, true); }
        else if (e.key === 'End') { e.preventDefault(); show(tabs.length - 1, true); }
      });
    });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { show(i); }); });
    // A swipe across the card on a phone moves to the next or previous tab.
    var card = root.querySelector('.wwh-card');
    var x0 = null;
    if (card) {
      card.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      card.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        x0 = null;
        if (Math.abs(dx) > 40) show(current + (dx < 0 ? 1 : -1));
      });
    }
    // Theme Editor: selecting a tab block shows it.
    scope.addEventListener('shopify:block:select', function (e) {
      var i = tabs.indexOf(e.target);
      if (i >= 0) show(i);
    });
  }

  /* ---------------------------------------------------------
     Wire a section up. Called on load and on Theme Editor events.
     --------------------------------------------------------- */
  /* One misbehaving block must not take the rest of the page down with it,
     so every initialiser is isolated. */
  function guard(name, fn) {
    try {
      return fn();
    } catch (err) {
      if (window.console && console.warn) console.warn('BIGME PDP: ' + name + ' failed', err);
      return null;
    }
  }

  function initSection(scope) {
    if (!scope) return;
    guard('videos', function () { hydrateVideos(scope); });
    guard('marquees', function () { initMarquees(scope); });
    var gallery = guard('gallery', function () { return initGallery(scope); });
    if (gallery) window.bigmeGallery = gallery;
    // Sticky first: it subscribes to the total that the buy box broadcasts on init.
    guard('sticky bar', function () { initSticky(scope); });
    guard('buy box', function () { initBuyBox(scope); });
    guard('supplement', function () { initSupplement(scope); });
    guard('actives', function () { initActives(scope); });
    guard('tabs', function () { initTabs(scope); });
    guard('social proof', function () { initSocialProof(scope); });
    guard('customer clips', function () { initClips(scope); });
    guard('video gallery', function () { initVideoCarousel(scope); });
    guard('stats', function () { initStats(scope); });
    guard('certifications', function () { initCertBand(scope); });
    guard('auto rails', function () { initAutoRails(scope); });
    guard('timeline', function () { initTimeline(scope); });
    guard('before/after', function () { initBeforeAfter(scope); });
    guard('faq', function () { initFaq(scope); });
  }

  ready(function () {
    document.body.classList.add('bigme-pdp-page');
    document.querySelectorAll('.bigme-pdp').forEach(initSection);
  });

  // Theme Editor: re-initialise a section after it is re-rendered.
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('.bigme-pdp').forEach(initSection);
  });
})();
